import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import LockIcon from "@material-ui/icons/Lock";
import LandingPageHeader from "../../LandingPage/views/LandingPageHeader";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { SaveResetPassword } from "../helper/forgotPasswordHelper";
import { error } from "../../../../store/notification/actions";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    marginTop: "10%",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  subtitle1: {
    fontSize: 13,
  },
}));

export default function ResetPassword(props) {
  const classes = useStyles();
  const { location } = props;
  const [state, setState] = useState({
    user_id: "",
    new_password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState([]);
  const [showPassword, setShowPassword] = useState({
    new_password: false,
    confirm_password: false,
  });
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setState({
      ...state,
      user_id: params.get("email"),
    });
    //eslint-disable-next-line
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const validate = (fieldValues = state) => {
    let temp = { ...errors };

    if ("user_id" in fieldValues) {
      temp.user_id = fieldValues.user_id === "" ? "User Id is required" : "";
    }

    if ("new_password" in fieldValues) {
      temp.new_password =
        fieldValues.new_password === "" ? "New Password is required" : "";
    }

    if ("confirm_password" in fieldValues) {
      temp.confirm_password =
        fieldValues.confirm_password === ""
          ? "Confirm Password is required"
          : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const validatePassword = () => {
    if (state.new_password !== state.confirm_password) {
      error("Passwords do not match");
      return false;
    } else {
      return true;
    }
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate() && validatePassword()) {
      SaveResetPassword(state);
    }
  };

  return (
    <React.Fragment>
      <LandingPageHeader />
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Container component="main" maxWidth="xs" className={classes.Appcss}>
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Enter New Password
            </Typography>
            <form className={classes.form} onSubmit={HandleSubmit}>
              <Typography className={classes.subtitle1} align="center">
                Please enter new password for your account
              </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="user_id"
                disabled
                label="User ID or Email"
                id="user_id"
                autoComplete="Enter User Id"
                value={state.user_id}
                onChange={handleInputChange}
                {...(errors.user_id && {
                  error: true,
                  helperText: errors.user_id,
                })}
              />
              <TextField
                autoFocus
                variant="outlined"
                margin="normal"
                fullWidth
                name="new_password"
                label="New Password"
                id="new_password"
                autoComplete="Enter New password"
                value={state.new_password}
                type={showPassword.new_password ? "text" : "password"}
                onChange={handleInputChange}
                {...(errors.new_password && {
                  error: true,
                  helperText: errors.new_password,
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword({
                            ...showPassword,
                            new_password: !showPassword.new_password,
                          });
                        }}
                      >
                        {showPassword.new_password ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="confirm_password"
                label="Re-type Password"
                id="confirm_password"
                autoComplete="Re-type New password"
                value={state.confirm_password}
                type={showPassword.confirm_password ? "text" : "password"}
                onChange={handleInputChange}
                {...(errors.confirm_password && {
                  error: true,
                  helperText: errors.confirm_password,
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword({
                            ...showPassword,
                            confirm_password: !showPassword.confirm_password,
                          });
                        }}
                      >
                        {showPassword.confirm_password ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="default"
                onClick={() => history.push("/")}
              >
                Cancel
              </Button>
            </form>
          </div>
        </Container>
      </Container>
      <LandingPageFooter />
    </React.Fragment>
  );
}
